// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.renter.v1.conversation.SatelliteWebRenterConversationHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  SatelliteWebRenterConversationHandler_addMessage,
  SatelliteWebRenterConversationHandler_getLatestConversations,
  SatelliteWebRenterConversationHandler_getLatestConversations_Path,
  SatelliteWebRenterConversationHandler_getMessages,
  SatelliteWebRenterConversationHandler_getMessages_Path,
  SatelliteWebRenterConversationHandler_updateStatus,
} from '@zg-rentals/ts-satellite-client';

import type {
  SatelliteWebRenterConversationAddMessageRequestDto,
  SatelliteWebRenterConversationAddMessageResponseDto,
  SatelliteWebRenterConversationGetLatestConversationsRequestDto,
  SatelliteWebRenterConversationGetLatestConversationsResponseDto,
  SatelliteWebRenterConversationGetMessagesRequestDto,
  SatelliteWebRenterConversationGetMessagesResponseDto,
  SatelliteWebRenterConversationUpdateStatusRequestDto,
} from '@zg-rentals/ts-satellite-client';

export interface SatelliteWebRenterConversationHandler_addMessage_Args {
  postData: SatelliteWebRenterConversationAddMessageRequestDto;
}

export type SatelliteWebRenterConversationHandler_addMessage_Options = UseMutationOptions<
  SatelliteWebRenterConversationAddMessageResponseDto,
  unknown,
  SatelliteWebRenterConversationHandler_addMessage_Args
>;

/**
 * Add a message to a conversation
 */
export const useSatelliteWebRenterConversationHandler_addMessage = ({
  httpClient,
  ...options
}: Omit<SatelliteWebRenterConversationHandler_addMessage_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebRenterConversationHandler_addMessage_Args) =>
      SatelliteWebRenterConversationHandler_addMessage(args.postData, httpClient),
  });
};

export type SatelliteWebRenterConversationHandler_getLatestConversations_Options = UseQueryOptions<
  SatelliteWebRenterConversationGetLatestConversationsResponseDto,
  unknown,
  SatelliteWebRenterConversationGetLatestConversationsResponseDto,
  Array<string | SatelliteWebRenterConversationGetLatestConversationsRequestDto>
>;

const SatelliteWebRenterConversationHandler_getLatestConversations_GetKey = (
  postData: SatelliteWebRenterConversationGetLatestConversationsRequestDto,
) => [SatelliteWebRenterConversationHandler_getLatestConversations_Path, postData];

/**
 * Get a renter's most recently updated conversations. Each conversation will include one message for that conversation. If the entire conversation consists of nothing but system messages, then the message included will be the most recent system message, otherwise the message included will be the most recent user message even if the most recent message is actually a system message. That is, system messages will only be returned if the entire conversation is composed solely of system messages.
 */
export const useSatelliteWebRenterConversationHandler_getLatestConversations = (
  postData: SatelliteWebRenterConversationGetLatestConversationsRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebRenterConversationHandler_getLatestConversations_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: SatelliteWebRenterConversationHandler_getLatestConversations_GetKey(postData),
    queryFn: () => SatelliteWebRenterConversationHandler_getLatestConversations(postData, httpClient),
  });
};
useSatelliteWebRenterConversationHandler_getLatestConversations.getKey =
  SatelliteWebRenterConversationHandler_getLatestConversations_GetKey;

export type SatelliteWebRenterConversationHandler_getMessages_Options = UseQueryOptions<
  SatelliteWebRenterConversationGetMessagesResponseDto,
  unknown,
  SatelliteWebRenterConversationGetMessagesResponseDto,
  Array<string | SatelliteWebRenterConversationGetMessagesRequestDto>
>;

const SatelliteWebRenterConversationHandler_getMessages_GetKey = (
  postData: SatelliteWebRenterConversationGetMessagesRequestDto,
) => [SatelliteWebRenterConversationHandler_getMessages_Path, postData];

/**
 * Get messages for a conversation
 */
export const useSatelliteWebRenterConversationHandler_getMessages = (
  postData: SatelliteWebRenterConversationGetMessagesRequestDto,
  {
    httpClient,
    ...options
  }: Omit<SatelliteWebRenterConversationHandler_getMessages_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: SatelliteWebRenterConversationHandler_getMessages_GetKey(postData),
    queryFn: () => SatelliteWebRenterConversationHandler_getMessages(postData, httpClient),
  });
};
useSatelliteWebRenterConversationHandler_getMessages.getKey = SatelliteWebRenterConversationHandler_getMessages_GetKey;

export interface SatelliteWebRenterConversationHandler_updateStatus_Args {
  postData: SatelliteWebRenterConversationUpdateStatusRequestDto;
}

export type SatelliteWebRenterConversationHandler_updateStatus_Options = UseMutationOptions<
  void,
  unknown,
  SatelliteWebRenterConversationHandler_updateStatus_Args
>;

/**
 * Update conversation status
 */
export const useSatelliteWebRenterConversationHandler_updateStatus = ({
  httpClient,
  ...options
}: Omit<SatelliteWebRenterConversationHandler_updateStatus_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: SatelliteWebRenterConversationHandler_updateStatus_Args) =>
      SatelliteWebRenterConversationHandler_updateStatus(args.postData, httpClient),
  });
};
